import React from 'react';
import LinesEllipsis from 'react-lines-ellipsis/lib/index';
import responsiveHOC from 'react-lines-ellipsis/lib/responsiveHOC';

import { t, triggerTrackingUrl } from '@insight/toolkit-utils';
import { PDPImage } from '../../PDPTabs/PDPImage';
import { Button } from '../../index';

const ResponsiveEllipsis = responsiveHOC()(LinesEllipsis);

export const BetterTogetherItem = ({
  isCurrentItem,
  materialId,
  src,
  alt,
  description,
  clickTrackingURL,
  setMiniPDP,
}) => {
  const openMiniPDP = () => {
    triggerTrackingUrl(clickTrackingURL);
    setMiniPDP(materialId);
  };

  const renderItem = () => {
    if (isCurrentItem) {
      return (
        <div className="c-product-better-together__item__container c-product-better-together__item__current">
          <div className="c-product-better-together__item-image">
            <PDPImage src={src} alt={alt} />
          </div>
          <div className="c-product-better-together__item__current-product">
            {`${t('Current product:')} `}
          </div>
          <div className="c-product-better-together__item__name">
            <ResponsiveEllipsis
              text={description}
              maxLine="3"
              ellipsis="..."
              trimRight
              basedOn="letters"
            />
          </div>
        </div>
      );
    }
    return (
      <Button
        className="c-product-better-together__item__container c-product-better-together__item__quick-view"
        color="none"
        onClick={() => openMiniPDP()}
      >
        <div className="c-product-better-together__item-image">
          <PDPImage src={src} alt={alt} />
        </div>
        <div className="c-product-better-together__item__spacer" />
        <div className="c-product-better-together__item__name">
          <ResponsiveEllipsis
            text={description}
            maxLine="3"
            ellipsis="..."
            trimRight
            basedOn="letters"
            aria-hidden="true"
          />
        </div>
        <span className="c-product-better-together__images__image__overlay">
          {t('Quick view')}
        </span>
      </Button>
    );
  };
  return (
    <div className="c-product-better-together__images__image">
      {renderItem()}
    </div>
  );
};

export default BetterTogetherItem;
